import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { IconWarningTriangle } from "./icons";

export const DuplicateSocSecModal = ({ show, onHide, onConfirm }) => {
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static">
      <Modal.Header
        closeButton
        className="px-4 border-0"
        style={{ backgroundColor: "#C2660A" }}
      >
        <Modal.Title className="d-flex align-items-center gap-3 fw-bold" style={{ color: "#FFFFFF" }}>
          <IconWarningTriangle size={24} style={{ color: "#FFFFFF" }} />
          <span style={{ color: "#FFFFFF" }}>{t("DuplicateSocSecTitle", "Henkilötunnus löytyy jo")}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="p-4">
        <p className="fw-bold text-center mb-0">
          {t("DuplicateSocSecWarning", "Järjestelmässä on jo henkilö samalla henkilötunnuksella. Haluatko varmasti luoda uuden profiilin?")}
        </p>
      </Modal.Body>

      <Modal.Footer className="border-0 pb-4">
        <Button className="btn-return" onClick={onHide}>
          {t("BackToForm", "Palaa muokkaamaan")}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("SaveAnyway", "Tallenna silti")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
